// Client-side mirror of the SQL predicate is_excluded_analytics_traffic()
// (supabase/migrations/20260903070000_analytics_bot_filter.sql).
//
// Used wherever we fetch raw analytics_events rows and aggregate in JS, so
// client-side charts agree with the SQL counting functions. Keep both in sync.

const BOT_UA_PATTERN =
  /bot|crawl|spider|slurp|headless|lighthouse|pagespeed|pingdom|uptimerobot|statuscake|scrapy|python|curl\/|wget\/|axios\/|node-fetch|go-http-client|okhttp|libwww|phantomjs|puppeteer|playwright|selenium|facebookexternalhit|semrush|ahrefs|mj12|bytespider|petalbot|gptbot|ccbot|claudebot|perplexity/i;

const DEV_URL_PATTERN =
  /localhost|127\.0\.0\.1|webcontainer-api\.io|stackblitz|\.local-credentialless\./i;

// Referrer-spoofing botnet signature observed Jul 2026: desktop Linux Chrome
// with a bare google.com referrer. Also drops genuine desktop-Linux organic
// Google clicks (~1% of real consumer traffic) - accepted trade-off.
const SPOOFED_REFERRER_PATTERN = /^https?:\/\/(www\.)?google\.[a-z.]+\/?$/i;

export interface AnalyticsEventTrafficFields {
  user_agent?: string | null;
  referrer?: string | null;
  page_url?: string | null;
}

export function isExcludedAnalyticsEvent(event: AnalyticsEventTrafficFields): boolean {
  const ua = event.user_agent?.trim() ?? '';
  if (!ua) return true;
  if (BOT_UA_PATTERN.test(ua)) return true;
  if (event.page_url && DEV_URL_PATTERN.test(event.page_url)) return true;
  if (
    ua.includes('X11; Linux x86_64') &&
    event.referrer &&
    SPOOFED_REFERRER_PATTERN.test(event.referrer)
  ) {
    return true;
  }
  return false;
}
